<div
  class="contact-role-theme contact-role-card group/contact-card shadow-sm"
  [attr.data-contact-role-color]="contactRoleDetails.color"
  [ngClass]="[
    contactRoleAssigned
      ? 'contact-role-card-assigned'
      : showRequiredValidation
        ? 'contact-role-card-required'
        : 'border-grey-concrete bg-white',
    !contactRoleAssigned && !contactsFormArray.disabled ? 'contact-role-card-interactive' : '',
    contactsFormArray.disabled ? 'pointer-events-none' : '',
    compactDesktop ? 'lg:w-full lg:min-w-0 lg:max-w-none' : '',
  ]"
  id="contact-role-{{ contactRole }}"
>
  <div class="flex items-start justify-between gap-1.5">
    <div class="min-w-0 flex-1">
      <div class="flex items-center gap-0.5 min-w-0">
        <div
          class="size-7 flex items-center justify-center shrink-0"
          [ngClass]="
            showRequiredValidation
              ? 'text-bright-crimson'
              : contactRoleAssigned
                ? 'text-[var(--role-color)]'
                : 'text-grey-mid'
          "
          [tooltip]="contactRoleAssigned ? contactRoleDetails.description : null"
        >
          <ion-icon [name]="contactRoleDetails.icon" class="size-5"></ion-icon>
        </div>
        <div class="min-w-0 text-left">
          <h2
            class="font-medium text-xs text-grey-blue leading-snug"
            [ngClass]="compactDesktop ? 'lg:line-clamp-2' : ''"
            [tooltip]="contactRoleAssigned ? contactRoleDetails.description : null"
          >
            {{ contactRoleTitle }} Contact
          </h2>
        </div>
      </div>
    </div>
    <div class="flex items-start gap-1 shrink-0">
      @if (showActionButton && contactRoleAssigned) {
        <button
          id="assign-btn-{{ contactRole }}"
          class="btn-default btn-icon contact-role-card-action"
          [class.review-mode]="reviewMode"
          [disabled]="contactsFormArray.disabled"
          (click)="$event.stopPropagation(); openPopover($event)"
          [attr.aria-label]="cardAction.label + ' for ' + contactRoleTitle"
          [tooltip]="cardAction.label"
        >
          <ion-icon class="size-3.5 shrink-0" [name]="cardAction.icon"></ion-icon>
        </button>
      }
    </div>
  </div>

  <div class="flex flex-col gap-1 flex-1">
    @if (!contactRoleAssigned && !!contactRoleDetails.description) {
      <p class="w-full text-left text-grey-mid/75 text-xxs font-normal leading-tight">
        @if (!required) {
          <span class="italic">Optional.</span>
        }
        {{ contactRoleDetails.description }}
      </p>
    }

    @if (showActionButton && !contactRoleAssigned) {
      <div class="flex justify-center pt-1">
        <button
          id="assign-btn-{{ contactRole }}"
          class="btn-default contact-role-assign-button"
          [disabled]="contactsFormArray.disabled"
          (click)="$event.stopPropagation(); openPopover($event)"
          [attr.aria-label]="cardAction.label + ' for ' + contactRoleTitle"
        >
          <ion-icon class="size-3.5 shrink-0" [name]="cardAction.icon"></ion-icon>
          <span class="whitespace-nowrap">Assign contact</span>
        </button>
      </div>
    }

    @if (assignedContactForms.length) {
      <div class="flex gap-1 my-auto empty:hidden justify-center flex-wrap">
        @for (contactForm of assignedContactForms; track contactForm.controls['email'].value; let index = $index) {
          <button
            [attr.id]="'contact-' + index + '-' + contactRole"
            class="group/contact-chip btn-default contact-role-chip"
            [disabled]="contactsFormArray.disabled"
            (click)="$event.stopPropagation(); removeContactRole(contactForm)"
            [tooltip]="contactForm.controls['name'].value"
            tooltipAction="Click to unassign"
            [attr.aria-label]="'Unassign ' + contactForm.controls['name'].value + ' from ' + contactRoleTitle"
          >
            <span class="contact-role-chip-icon-shell p-1">
              <ion-icon name="person" class="contact-role-chip-icon-default size-3"></ion-icon>
              <ion-icon name="close" class="contact-role-chip-icon-hover size-3 text-bright-crimson"></ion-icon>
            </span>
            <span class="max-w-full text-[11px] leading-none font-medium text-grey-blue truncate">
              {{ contactForm.controls['name'].value }}
            </span>
          </button>
        }
      </div>
    }

    @if (
      groupType !== 'customer' &&
      groupEdit &&
      contactRole == 'partner' &&
      contactFormGroups[0]?.controls['contact_roles']?.value?.includes(contactRole) &&
      contactFormGroups[0]?.pristine
    ) {
      <div class="flex justify-center">
        <button
          id="update-all-customers"
          class="btn-primary btn-xs"
          [disabled]="contactsFormArray.disabled"
          (click)="$event.stopPropagation(); updateAllCustomers.emit()"
        >
          Update All Customers
        </button>
      </div>
    }

    @if (showRequiredValidation) {
      <div class="mt-auto flex items-end justify-between gap-2">
        <p
          class="text-bright-crimson text-xxs font-normal flex items-center gap-1"
          id="contact-role-error-{{ contactRole }}"
        >
          <ion-icon name="alert-circle" class="size-3"></ion-icon>
          Required
        </p>
      </div>
    }
  </div>

  <ion-popover
    #contactPopover
    [keepContentsMounted]="false"
    [dismissOnSelect]="true"
    size="auto"
    mode="md"
    translucent="true"
    class="contact-role-popover-shell"
    style="--width: 300px; --max-width: calc(100vw - 1rem)"
  >
    <ng-template>
      <div
        class="contact-role-theme contact-role-popover-panel"
        [attr.data-contact-role-color]="contactRoleDetails.color"
      >
        <div class="contact-role-popover-header">
          <div class="flex items-start justify-between gap-2 min-w-0">
            <div class="min-w-0 flex-1 text-left">
              <p class="m-0 mt-2 text-[10px] font-medium uppercase tracking-[0.12em] text-grey-mid/80">
                {{ contactRoleAssigned ? 'Manage role' : 'Assign role' }}
              </p>
              <h2 class="m-0 pt-0.5 text-[13px] font-medium leading-tight text-grey-blue line-clamp-2">
                {{ contactRoleTitle }} Contact
              </h2>
            </div>
            <div class="contact-role-popover-icon">
              <ion-icon [name]="contactRoleDetails.icon" class="size-5"></ion-icon>
            </div>
          </div>
          @if (!!contactRoleDetails.description) {
            <p class="m-0 pb-2 text-[11px] font-normal leading-snug text-grey-mid">
              {{ contactRoleDetails.description }}
            </p>
          }
          @if (isSingleUseRole) {
            <div
              class="mt-1 flex min-w-0 w-full items-start gap-1 text-[0.6875rem] font-normal leading-[1.5] text-bright-orange"
            >
              <ion-icon name="alert-circle" class="size-3.5 text-bright-orange shrink-0"></ion-icon>
              <span class="min-w-0">Only 1 contact can be assigned to this role.</span>
            </div>
          }
        </div>

        <div class="m-0 box-border overflow-x-hidden pt-1">
          @if (availableContactForms.length) {
            <div class="mb-1 px-2.5">
              <p class="m-0 text-[11px] text-center font-medium text-grey-blue/50">Available contacts</p>
            </div>
          }

          <div class="flex flex-col overflow-x-hidden">
            @for (contactForm of availableContactForms; track contactForm.controls['email'].value; let index = $index) {
              <button
                id="assign-contact-{{ contactRole }}-{{ index }}"
                type="button"
                class="contact-role-popover-option shadow-xs"
                [disabled]="contactsFormArray.disabled"
                (click)="$event.stopPropagation(); assignContactToRole(contactForm)"
              >
                <div
                  class="inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-[rgb(232_234_237)] text-slate-500"
                >
                  <ion-icon name="person" class="size-4"></ion-icon>
                </div>
                <div class="min-w-0 flex-1 text-left">
                  <p class="m-0 truncate text-xs font-medium text-grey-blue">
                    {{ contactForm.controls['name'].value }}
                  </p>
                  <div class="mt-px flex items-center gap-1 text-[10px] text-grey-mid min-w-0 overflow-hidden">
                    @if (contactForm.controls['contact_position'].value) {
                      <span class="truncate capitalize shrink-0 max-w-[7rem]">{{
                        contactForm.controls['contact_position'].value
                      }}</span>
                      <span class="shrink-0 text-grey-mid/50">•</span>
                    }
                    <span class="truncate min-w-0">{{ contactForm.controls['email'].value }}</span>
                  </div>
                </div>
                <div
                  class="inline-flex size-4 shrink-0 items-center justify-center justify-self-end text-slate-500"
                  aria-hidden="true"
                >
                  <ion-icon name="chevron-forward-outline" class="size-4"></ion-icon>
                </div>
              </button>
            } @empty {
              <div
                class="m-2 flex flex-col items-center justify-center gap-0.5 rounded-xl border border-dashed border-slate-300 bg-slate-50/65 p-2 text-center"
              >
                <ion-icon name="people-outline" class="size-4 text-grey-mid/60"></ion-icon>
                <p class="m-0 text-xs font-medium text-grey-blue">No more contacts available</p>
                <p class="m-0 text-[10px] font-normal text-grey-mid">Add someone new to assign this role.</p>
              </div>
            }
          </div>
        </div>

        <div class="m-0 flex overflow-x-hidden px-2.5 py-1.5">
          <button
            id="add-contact-from-role"
            type="button"
            class="btn-default text-xs mx-auto my-1 inline-flex items-center justify-center gap-2"
            [disabled]="contactsFormArray.disabled"
            (click)="$event.stopPropagation(); addNewContactForRole()"
          >
            <ion-icon class="size-4" name="add"></ion-icon>
            <span>Add New Contact</span>
          </button>
        </div>
      </div>
    </ng-template>
  </ion-popover>
</div>
